export default class ContentPortrait {
  static init() {
    // Utilisation de querySelectorAll au cas où il y aurait plusieurs sections sur la même page
    const sections = document.querySelectorAll('[data-module="content-portrait"]');

    if (!sections.length) {
      return;
    }

    sections.forEach((section) => {
      const toggleButton = section.querySelector('[data-content-portrait-toggle]');
      const membersPanel = section.querySelector('.content-portrait__members');

      if (toggleButton && membersPanel) {
        const openLabel = toggleButton.dataset.openLabel || 'Afficher tous les membres';
        const closeLabel = toggleButton.dataset.closeLabel || 'Afficher moins';
        const textElement = toggleButton.querySelector('.content-portrait__toggle-text');
        const openIcon = toggleButton.querySelector('.content-portrait__toggle-icon--open');
        const closeIcon = toggleButton.querySelector('.content-portrait__toggle-icon--close');

        const setOpen = (open) => {
          section.classList.toggle('is-open', open);
          membersPanel.setAttribute('aria-hidden', String(!open));
          toggleButton.setAttribute('aria-expanded', String(open));

          if (textElement) {
            textElement.textContent = open ? closeLabel : openLabel;
          }

          if (openIcon) {
            openIcon.style.display = open ? 'none' : '';
          }

          if (closeIcon) {
            closeIcon.style.display = open ? '' : 'none';
          }
        };

        toggleButton.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(!section.classList.contains('is-open'));
        });

        setOpen(false);
      }
    });
  }
}